<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="false"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :searchAttrName="searchAttrName"
      :pageSize="20"
      height="calc(100vh - 210px)"
      :showPagination="true"
      rowKey="productRecordsId"
      tableName="warehouseProRecord"
      exportDataUrl="/outInputRecords/selectProductInventoryByProductRecordsId"
      @onSearch="handleSearch"
    >
    </Table>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { ref, watch, getCurrentInstance, onMounted } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import { selectProductInventoryByProductRecordsId } from "@/api/warehouse/warehouseDate";
import useCacheStore from "@/store/modules/cache";
import { isNull } from "@/utils/fangerUtils";
import { succesMsg } from "@/utils/msgBox";
import { useRoute } from "vue-router";
const cacheStore = useCacheStore();

const { getProductById } = cacheStore;
const { proxy } = getCurrentInstance();
/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "warehouseProRecord",
});
const searchAttrName = ["eqptCode"];
const proId = ref();
const route = useRoute();
const tableRef = ref(null);
onMounted(() => {
  watch(
    () => route.query,
    (newVal, oldVal) => {
      if (newVal) {
        proId.value = newVal.proId || "";
        proxy.$nextTick(() => {
          tableRef.value.onSearch();
        });
      }
      // proSearch()
    },
    {
      immediate: true,
    }
  );
});
const tableData = ref([]);

const total = ref(0);
const loading = ref(false);

// 搜索
const handleSearch = (data) => {
  loading.value = true;
  selectProductInventoryByProductRecordsId({ productRecordsId: proId.value })
    .then((res) => {
      tableData.value = res.data;
      total.value = tableData.value.length;
    })
    .finally(() => {
      loading.value = false;
    });
};

const columns = getCustomTableCols([
  "contractNo",
  "batchNo",
  "projectNo",
  "workContactNo",
  "projectName",
  "checkStatus",
  "returnInWarehouse",
  "firstInWarehouseTime",
  "inWarehouseTime",
  "inventoryStatus",
  "outWarehouseTime",
  "checkInventoryDisposalMode",
  "eqptCode",
  "productNum",
  "inventoryOperationType",
  "remarks",
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped></style>
